import { RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";

export type B100090CreateRequest = {
  ginkoCd: string;
  ginkoshitenCd: string;
  ginkoNm: string;
  shitenNm: string;
  sakujoyoteiKbn: string;
} & Partial<{
  ginkoKana: string;
  shitenKana: string;
}>;

//新規登録処理
export const B100090Create = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100090CreateRequest = {
    ginkoCd: fields.ginkoCd,
    ginkoshitenCd: fields.ginkoshitenCd,
    ginkoNm: fields.ginkoNm,
    shitenNm: fields.shitenNm,
    sakujoyoteiKbn: fields.sakujoyoteiKbn!.value,
    ginkoKana: fields.ginkoKana,
    shitenKana: fields.shitenKana,
  };

  return RestClient.post("b100090/create", data);
};

export type B100090UpdateRequest = {
  ginkoCd: string;
  ginkoshitenCd: string;
  ginkoNm: string;
  shitenNm: string;
  sakujoyoteiKbn: string;
  version: string;
} & Partial<{
  ginkoKana: string;
  shitenKana: string;
}>;

//更新処理
export const B100090Update = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100090UpdateRequest = {
    ginkoCd: fields.ginkoCd,
    ginkoshitenCd: fields.ginkoshitenCd,
    ginkoNm: fields.ginkoNm,
    shitenNm: fields.shitenNm,
    sakujoyoteiKbn: fields.sakujoyoteiKbn!.value,
    ginkoKana: fields.ginkoKana,
    shitenKana: fields.shitenKana,
    version: fields.version,
  };

  return RestClient.put("b100090/update", data);
};

export type B100090GetRequest = {
  ginkoCd: string;
};

export const B100090Get = (props: B100090GetRequest) => {
  return RestClient.get("b100090/get", {
    params: props,
  });
};
